<template>
	<div class="container">
		<div class="row justify-content-center align-items-center" id="baday">
			<div class="card border-secondary">
				<div class="card-body">
					<form @submit.prevent="login">
						<div class="row mb-3"><h3>Login</h3></div>
						<div v-if="error" class="alert alert-danger" role="alert">{{reason}}</div>
						<div class="row mb-4">
							<label for="inputEmail" class="col-sm-3 col-form-label">Username</label>
							<div class="col-sm-9">
								<input class="form-control" id="inputEmail" v-model="username" />
							</div>
						</div>
						<div class="row mb-4">
							<label for="inputPassword" class="col-sm-3 col-form-label">Password</label>
							<div class="col-sm-9">
								<input type="password" class="form-control" id="inputPassword" v-model="password"/>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-sm-10 offset-sm-2">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" id="gridCheck1" v-model="saveme" />
									<label class="form-check-label" for="gridCheck1">Remember me on this computer for 30 days.</label>
								</div>
							</div>
						</div>
						<div class="text-right">
							<button class="btn btn-primary" type="submit">Login</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import config from "../config"
import $ from "jquery"
export default {
	data() {
		return {
			username: "",
			password: "",
			error: false,
			reason: "",
			saveme: false,
		};
	},
	methods: {
		async login() {
			console.log(this.saveme);
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },

				body: JSON.stringify({
					data: {
						username: this.username,
						password: this.password,
					},
				}),
			};
			const response = await fetch(config.baseURL + "/login", requestOptions);
			const data = await response.json();
			console.log(data);
			if (data["Accepted"]) {
				if (this.saveme) this.$router.push("/verify/1/" + data["user_id"]);
				else this.$router.push("/verify/0/" + data["user_id"]);
			} else {
				this.reason = data["reason"];
				this.error = true;
			}
		},
	},
	mounted() {
		$(".navbar").remove();
		this.$cookies.remove("id");
	},
};
</script>

<style scoped>
#nav {
	display: none;
}
.card {
	max-width: 30rem;
	background-color: #f8f8f8;
}
#baday {
	min-height: 80vh;
}
.btn {
	float: right;
}
.container {
	position: relative;
}
.container::before {
	content: "";
	background-image: url("https://quotey.io/wp-content/uploads/2020/10/robot.bmp");
	background-size: 30rem;
	background-repeat: no-repeat;
	position: absolute;
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
	opacity: 40%;
	height: 730px;
	background-position: right center;
	background-repeat: no-repeat;
	background-attachment: scroll;
	background-size: 30rem;
}
</style>
